const numArray = [1,2,3,4,5,6,7,8,9,0];

const smallArr = ['a','b','c','d','e','f','g','q','w','e','r','t','y','u','i','o','p','s','j','k','l','z','x','v','n','m'];
const capArr = ['Q','W','E','R','T','Y','U','I','O','P','A','S','D','F','G','H','J','K','L','Z','X','C','V','B','N','M'];
const spArr = ['!','@','#','$','%','^','&','*','+','/']

const mixArr = ['Q','W','E','R','T','a','b','c','d','e',4,5,6,7,8];
const spMix = ['$','%','^','&','r','t','y','u',1,2];

export {numArray, smallArr, capArr, spArr, mixArr, spMix};